import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { MaterialModule } from "../../../modules/material/material.module";
import { PipesModule } from "../../shared/pipes/pipes.module";
import { TableModule } from "../../shared/components/table/onsip-table.module";
import { FormEventTrackingModule } from "../../shared/components/analytics/form-event-tracking.module";
import { ThreeColumnModule } from "../../shared/components/layout/threeColumn/three-column.module";
import { FakeMatListChipsModule } from "../../shared/components/fakeMatListChips/fake-mat-list-chips.module";
import { SelectionListDeluxeModule } from "../../shared/components/pickers/selectionListDeluxe/selection-list-deluxe.module";
import { AddressAutocompleteModule } from "../addressAutocomplete/address-autocomplete.module";
import { AudioRecorderModule } from "../../shared/components/audioRecorder/audio-recorder.module";

import { AdminVoicemailComponent } from "./admin-voicemail.component";
import { AdminVoicemailShelfComponent } from "./adminVoicemailShelf/admin-voicemail-shelf-container.component";
import { AdminVoicemailBasicTabComponent } from "./adminVoicemailShelf/adminVoicemailBasic/admin-voicemail-basic-tab.component";
import { AdminVoicemailBasicViewComponent } from "./adminVoicemailShelf/adminVoicemailBasic/adminVoicemailBasicView/admin-voicemail-basic-view.component";
import { AdminVoicemailBasicEditComponent } from "./adminVoicemailShelf/adminVoicemailBasic/adminVoicemailBasicEdit/admin-voicemail-basic-edit.component";
import { AdminVoicemailAdvancedTabComponent } from "./adminVoicemailShelf/adminVoicemailAdvanced/admin-voicemail-advanced-tab.component";
import { AdminVoicemailAdvancedViewComponent } from "./adminVoicemailShelf/adminVoicemailAdvanced/adminVoicemailAdvancedView/admin-voicemail-advanced-view.component";
import { AdminVoicemailAdvancedEditComponent } from "./adminVoicemailShelf/adminVoicemailAdvanced/adminVoicemailAdvancedEdit/admin-voicemail-advanced-edit.component";
import { AdminVoicemailSetupComponent } from "./adminVoicemailSetup/admin-voicemail-setup.component";
import { AdminVoicemailGreetingTabComponent } from "./adminVoicemailShelf/adminVoicemailGreeting/admin-voicemail-greeting-tab.component";
import { AdminVoicemailGreetingViewComponent } from "./adminVoicemailShelf/adminVoicemailGreeting/adminVoicemailGreetingView/admin-voicemail-greeting-view.component";
import { AdminVoicemailGreetingEditComponent } from "./adminVoicemailShelf/adminVoicemailGreeting/adminVoicemailGreetingEdit/admin-voicemail-greeting-edit.component";
import { AdminVoiceMailRoutingModule } from "@onsip/web/features/administrators/voicemail/adminVoiceMailRouting.module";
import { ExtensionsListModule } from "@onsip/web/features/shared/components/extensionsList/extensions-list.module";
import { SipAddressFieldModule } from "../../shared/components/sipAddressField/sip-address-field.module";
import { TableDataLoadContainerModule } from "../../shared/components/tableDataLoadContainer/table-data-load-container.module";
import { TogglableRecorderModule } from "../../shared/components/togglableRecorder/togglable-recorder.module";
import { VmManagerLinkModule } from "../../shared/components/vmManagerLink/vm-manager-link.module";
import { VoiceEmailEmptyDataComponent } from "./voice-email-empty-data/voice-email-empty-data.component";
import { LoadingContainerComponent } from "../../shared/components/loadingContainer/loading-container.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    TranslateModule,
    RouterModule,
    PipesModule,
    TableModule,
    FormEventTrackingModule,
    ThreeColumnModule,
    FakeMatListChipsModule,
    SelectionListDeluxeModule,
    AddressAutocompleteModule,
    AudioRecorderModule,
    AdminVoiceMailRoutingModule,
    SipAddressFieldModule,
    ExtensionsListModule,
    TableDataLoadContainerModule,
    TogglableRecorderModule,
    VmManagerLinkModule,
    LoadingContainerComponent
  ],
  declarations: [
    AdminVoicemailComponent,
    AdminVoicemailShelfComponent,
    AdminVoicemailBasicTabComponent,
    AdminVoicemailBasicViewComponent,
    AdminVoicemailAdvancedTabComponent,
    AdminVoicemailAdvancedViewComponent,
    AdminVoicemailAdvancedEditComponent,
    AdminVoicemailSetupComponent,
    AdminVoicemailBasicEditComponent,
    AdminVoicemailGreetingTabComponent,
    AdminVoicemailGreetingViewComponent,
    AdminVoicemailGreetingEditComponent,
    VoiceEmailEmptyDataComponent
  ]
})
export class AdminVoicemailModule {}
